import { Loader } from '@/shared/components/ui/loader';
import { cn } from '@/shared/lib/utils';
import React from 'react';

interface LoadingSpinnerProps {
  tip?: string;
  fullscreen?: boolean;
  className?: string;
  /** RDS Loader size — 기본 medium(40px) */
  size?: 'giant' | 'large' | 'medium' | 'small' | 'tiny';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  tip,
  fullscreen = false,
  className,
  size = 'medium',
}) => {
  const content = (
    <div className={cn('flex flex-col items-center justify-center gap-3', className)}>
      <Loader size={size} />
      {tip && <p className="text-sm text-muted-foreground">{tip}</p>}
    </div>
  );

  if (fullscreen) {
    return (
      <div
        className={cn(
          'fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm',
          className,
        )}
      >
        {content}
      </div>
    );
  }

  return content;
};
